import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/coursesitesCourseScreencast'

export default function CourseSitesCourseScreencast() {
  return <ProjectLayout data={data} />
}
